export default "__VITE_ASSET__Bmw6HEV8__"